module.exports = __webpack_public_path__ + "static/img/brand-10.bbe6511.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand-10.svg
// module id = TiW2
// module chunks = 0